import React from 'react';
import { Link } from 'react-router';


class OrganizationsPagination extends React.Component {
  constructor(props) {
    super(props);
  }

  gotoPage = e => {
    setTimeout(function() {
    }, 0);
  };

  render() {
    if (!this.props.organizations.isLoaded) {
      return <span />;
    }

    const { page_links, next, previous, offset, limit, count } = this.props.organizations;
    const { nextLabel, prevLabel } = this.props
    let nextLink, previousLink = '';
    let page_options = [];
    if(previous) {
      previousLink = <div onClick={this.props.previousPage} className="organizations-paginationPrevious">
        {(prevLabel) ? prevLabel : 'prev'}
      </div>;
    }

    let pageLinks = page_links.map(plink => {
      let linkLabel = plink.number;
      let classNames = "organizations-paginationPageLink";
      if (plink.isBreak) {
        linkLabel = '...';
      }
      if (plink.isActive) {
        classNames = `${classNames} active`;
      }
      return (
        <div onClick={() => { this.props.pageJump(plink.number); }} className={classNames}>{linkLabel}</div>
      );
    });
    if (pageLinks.length == 1) {
      pageLinks = '';
    }

    if (next) {
      nextLink = <div onClick={this.props.nextPage} className="organizations-paginationNext">
        { (nextLabel) ? nextLabel : 'next'}
        </div>
    }

    return (
      <div className="organizations-pagination">
        {previousLink}
        <div className="organizations-paginationPageNumbers">{pageLinks}</div>
        {nextLink}
      </div>
    );
  }
}

export default OrganizationsPagination;



// WEBPACK FOOTER //
// ./src/components/OrganizationsPagination.jsx